export default "__VITE_ASSET__D$wDwnWq__"